// Shared token refresh coordinator - prevents dual refresh collisions
// Both axios.js and apiService.js use this instead of maintaining isolated state

let isRefreshing = false;
let refreshPromise = null;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

export const getIsRefreshing = () => isRefreshing;

export const getRefreshPromise = () => refreshPromise;

export const setRefreshPromise = (promise) => {
  refreshPromise = promise;
};

export const queueRequest = (promise) => {
  failedQueue.push(promise);
};

export const processAndClearQueue = (error, token = null) => {
  processQueue(error, token);
  failedQueue = [];
};

export const setRefreshing = (value) => {
  isRefreshing = value;
};